//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import effectScatter from '@/components/bigDataChart/effectScatter';
import { queryRealtime } from '@/api/api'; // import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'servicePopulation',
  //   mixins: [listenMapChange],
  created: function created() {
    this.queryWaterType();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    }
  },
  components: {
    effectScatter: effectScatter
  },
  methods: {
    queryWaterType: function queryWaterType(areaId, projectId) {
      var _this = this;

      queryRealtime({
        type: 1,
        id: 8
      }).then(function (res) {
        var datalist = [{
          offset: [70, 20],
          symbolSize: 30,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#29c0fb'
          }, {
            offset: 1,
            color: '#2dc5b9'
          }])
        }, {
          offset: [40, 75],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#35d17e'
          }, {
            offset: 1,
            color: '#49ddb2'
          }])
        }, {
          offset: [10, 43],
          symbolSize: 100,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#e5d273'
          }, {
            offset: 1,
            color: '#e4a37f'
          }])
        }, {
          offset: [44, 30],
          symbolSize: 100,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#277aec'
          }, {
            offset: 1,
            color: '#57c5ec'
          }])
        }, {
          offset: [75, 65],
          symbolSize: 75,
          opacity: 0.7,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#11c46e'
          }, {
            offset: 1,
            color: '#f08456'
          }])
        }, {
          offset: [95, 25],
          symbolSize: 75,
          opacity: 0.7,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#11c46e'
          }, {
            offset: 1,
            color: '#f08456'
          }])
        }];
        var data = [{
          name: '水温',
          value: res.result.records[0].dataMap['u10101'].value + "℃"
        }, {
          name: 'PH',
          value: res.result.records[0].dataMap['u10201'].value
        }, {
          name: '浊度',
          value: res.result.records[0].dataMap['u10302'].value + 'Turb' // value: 4.5+'Turb',

        }, {
          name: '原水浊度',
          value: res.result.records[0].dataMap['u10901'].value + 'Turb'
        }, {
          name: '电导率',
          value: res.result.records[0].dataMap['u10401'].value + 'μs/cm'
        }, {
          name: '溶解氧',
          value: res.result.records[0].dataMap['u10501'].value + "mg/L"
        }];

        _this.$refs.chart1.initEffectScatterChart(data, datalist);
      });
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWaterType(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWaterType(value, this.currentProjectId)
  //     },
  //   },

};